import { Navigate } from 'react-router-dom';
import { useWizardCurrentTaskUrl } from '../utils/hooks';

export const WizardIndex = () => {
  const currentTaskUrl = useWizardCurrentTaskUrl();

  if (currentTaskUrl) {
    return <Navigate to={currentTaskUrl} replace />;
  }

  return <Navigate to="welcome" replace />;
};
